import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

const About = () => {
    return (
        <section id="about" className="section" aria-labelledby="about-heading">
            <h2 id="about-heading" className="visually-hidden">About</h2>
            <div className="section-content">
                <p>
                    I’m a Computer Engineering graduate with a passion for programming and experience in web and mobile development. I’ve worked on POS systems, Flutter applications, and AI-related projects, focusing on building practical and well-structured solutions.
                </p>

                <p>
                    I apply my technical knowledge and project experience to real-world applications, continually improving my skills and exploring new technologies.
                </p>

                <p>
                    I am part of the team building our startup company, ZeroOne I.T Solutions, and I also contribute to the PERATI team.
                </p>
                <div className="about-affiliations" aria-label="Affiliations">
                    <a
                        href="https://aboutus.zeroone-apps.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="about-affiliation-link"
                    >
                        Zero One I.T Solutions <FaExternalLinkAlt style={{ fontSize: '0.75rem', marginLeft: '4px' }} />
                    </a>
                    <a
                        href="https://www.perati.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="about-affiliation-link"
                    >
                        PERATI <FaExternalLinkAlt style={{ fontSize: '0.75rem', marginLeft: '4px' }} />
                    </a>
                </div>

                <p>
                    In my free time, I enjoy playing online games and exploring new tech ideas.
                </p>
            </div>
        </section>
    );
};

export default About;
